module.exports = "<app-widgets-navbar entries=$ctrl.entries current-tab-form-valid=$ctrl.currentTabFormValid validate=$ctrl.validate switch-tab-prefix=$ctrl.switchTabPrefix> </app-widgets-navbar> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/route/navbar/partial.html
// module id = 491
// module chunks = 0